import type { DateRange } from '@witmetrics/utils';
import {
  useDateFormatPreference,
  useWeekStartsOnPreference,
} from '@witmetrics/data-store';
import ListItem from './ListItem';
import type { TimeframeOption } from './types';
import { buildTimeframeOptions, classes } from './utils';

export type DefaultOptionsListProps = {
  onSelect: (timeframe: DateRange) => void;
};

export default function DefaultOptionsList({
  onSelect,
}: DefaultOptionsListProps) {
  const dateFormat = useDateFormatPreference();
  const weekStartsOn = useWeekStartsOnPreference();

  const renderOption = (option: TimeframeOption) => (
    <ListItem
      key={option.value}
      label={option.label}
      subtitle={option.subtitle}
      onClick={() => onSelect(option.range)}
    />
  );

  const options = buildTimeframeOptions(weekStartsOn, dateFormat);

  return (
    <div className={classes.wrapper}>
      <div className={classes.list}>{options.map(renderOption)}</div>
    </div>
  );
}
